import { render, staticRenderFns } from "./edit-profile.vue?vue&type=template&id=c1c46b8a"
import script from "./edit-profile.vue?vue&type=script&lang=js"
export * from "./edit-profile.vue?vue&type=script&lang=js"
import style0 from "./edit-profile.vue?vue&type=style&index=0&id=c1c46b8a&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/Resourced/Resourced/Frontend-old/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c1c46b8a')) {
      api.createRecord('c1c46b8a', component.options)
    } else {
      api.reload('c1c46b8a', component.options)
    }
    module.hot.accept("./edit-profile.vue?vue&type=template&id=c1c46b8a", function () {
      api.rerender('c1c46b8a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "public/pages/account/edit-profile.vue"
export default component.exports